<template>
  <el-row class="form-container">
    <div class="el-descriptions-title">订单信息</div>
    <el-col v-if="['7', '10', '6', '11'].includes(subStatus)" :span="12">
      <span class="el-descriptions-item-label">审核信息：</span>
      <span class="el-descriptions-item-content" style="color: #e50113">
        审核驳回，您的申请于{{
          info.refuseAuditLogVO.createTime
        }}审核驳回，驳回原因：{{ info.refuseAuditLogVO.remark }}。
      </span>
    </el-col>
    <template v-for="item in baseList">
      <el-col :key="item.key" :span="12" :offset="item.offset || 0">
        <span
          :style="{ width: 'totalAmount' === item.key ? '84px' : 'auto' }"
          class="el-descriptions-item-label"
          >{{ item.label }}：</span
        ><span
          :class="[
            'el-descriptions-item-content',
            { 'total-price': 'totalAmount' === item.key },
          ]"
        >
          <template
            v-if="['siteReviewFee', 'amount', 'totalAmount'].includes(item.key)"
            >{{ info[item.key] | thousandsSeparator }}</template
          >
          <template v-else>{{ info[item.key] }}</template>
        </span>
      </el-col>
    </template>
    <el-col style="overflow: hidden; line-height: 0" :span="24">
      <svg
        style="vertical-align: top"
        xmlns="http://www.w3.org/2000/svg"
        width="3000"
        height="2"
        viewBox="0 0 3000 2"
        fill="none"
      >
        <path d="M0 1H3000" stroke="#C5C5C5" stroke-dasharray="2 2" />
      </svg>
    </el-col>
    <el-col :span="12">
      <span class="el-descriptions-item-label">制造单位：</span
      ><span class="el-descriptions-item-content">{{ info.companyName }}</span>
    </el-col>
    <el-col :span="12">
      <span style="width: 84px" class="el-descriptions-item-label"
        >生产地址：</span
      ><span class="el-descriptions-item-content">{{ info.factory }}</span>
    </el-col>
    <template v-for="(item, index) in list">
      <el-col :key="item.key" :span="12">
        <span
          :style="{ width: index % 2 === 1 ? '84px' : 'auto' }"
          class="el-descriptions-item-label"
          >{{ item.label }}：</span
        ><span class="el-descriptions-item-content">{{ info[item.key] }}</span>
      </el-col>
    </template>
  </el-row>
</template>

<script>
export default {
  name: 'OrderInfo',
  props: {
    // 0：企业信息审核，1：报告审核，2：评价业务管理
    type: {
      type: String,
      default: '0',
    },
    info: {
      type: Object,
      default: () => {
        return {};
      },
    },
    list: {
      type: Array,
      default: () => {
        return [];
      },
    },
    //
    subStatus: {
      type: String,
      default: '',
    },
  },
  computed: {
    baseList() {
      if (['7', '8'].includes(this.subStatus)) {
        return [
          { label: '现场审查费', key: 'siteReviewFee' },
          { label: '申请单号', key: 'applyCode' },
          { label: '产品检测费', key: 'amount' },
          { label: '申请日期', key: 'applyTime' },
          { label: '总评价费', key: 'totalAmount' },
        ];
      }
      return [
        { label: '申请单号', key: 'applyCode' },
        { label: '现场审查费', key: 'siteReviewFee' },
        { label: '申请日期', key: 'applyTime' },
        { label: '产品检测费', key: 'amount' },
        { label: '总评价费', key: 'totalAmount', offset: 12 },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
@import './common';

.form-container {
  padding-bottom: 0 !important;
}
</style>
